import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/images/placeholder.png'
import _imports_1 from '@/assets/videos/reveal.mp4'


const _hoisted_1 = { class: "flex flex-col w-full flex-1 items-center justify-center" }
const _hoisted_2 = { class: "relative flex w-full lg:w-96 lg:h-96 z-10" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_1,
  type: "video/mp4"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MintPreview',
  props: ["image", "alt"],
  setup(__props, { expose }) {



const video = ref<HTMLVideoElement>();

onMounted(() => {
    if (video.value) {
        video.value.playbackRate = 1.5;
    }
});

const play = function () {
    video.value?.play();
};

const pause = function () {
    video.value?.pause();
};

expose({ play, pause });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "block w-full",
            src: __props.image,
            alt: __props.alt
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("video", {
            key: 1,
            ref_key: "video",
            ref: video,
            loop: "",
            preload: "auto",
            class: "block w-full object-cover",
            poster: _imports_0
          }, _hoisted_5, 512))
    ])
  ]))
}
}

})